import logo from './logo.svg';
import './App.css';
import React from "react";
import MiniDrawer from "./Drawer";
import EditorFile from "./EditorFile";


function App() {
  return (
    <div className="App">
        <MiniDrawer/>

    </div>
  );
}

export default App;
